export const ID_DRAFT = "DRAFT";
export const ID_READY = "READY";
export const ID_DISMISSED = "DISMISSED";